import { render, staticRenderFns } from "./dokobit-signing-window.vue?vue&type=template&id=5442eef6&scoped=true"
import script from "./dokobit-signing-window.vue?vue&type=script&lang=js"
export * from "./dokobit-signing-window.vue?vue&type=script&lang=js"
import style0 from "./dokobit-signing-window.vue?vue&type=style&index=0&id=5442eef6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5442eef6",
  null
  
)

export default component.exports